import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({


  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    marginBottom: 10,
    // paddingHorizontal: 20,
  },
  leftColumn: {
    width: "50%",
  },
  rightColumn: {
    width: "50%",
    textAlign: "right",
  },
  heading: {
    fontSize: 10,
    color: 'black',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  text: {
    fontSize: 9,
    lineHeight: 1.5,
  },
});

const CustomerName = ({ invoice }) => {
  const invoiceParsed = JSON.parse(JSON.parse(JSON.stringify(invoice)));
  const client = invoiceParsed.child[0];

  return (
    <Fragment>
      <View style={styles.container}>
        <View style={styles.leftColumn}>
          <Text style={styles.heading}>Agent Details:</Text>
          <Text style={styles.text}>
            {invoiceParsed.agentdetails.corporate_name}{"\n"}
            {invoiceParsed?.agentdetails?.address}, {invoiceParsed?.agentdetails?.city}.{"\n"}
            {invoiceParsed?.agentdetails?.island}, {invoiceParsed?.agentdetails?.agent_country} -{" "}
            {invoiceParsed?.agentdetails?.zip_code}
          </Text>
        </View>

        <View style={styles.rightColumn}>
          <Text style={styles.heading}>Contact Details:</Text>
          <Text style={styles.text}>
            Contact Person: {client?.first_name} {client?.last_name}{"\n"}
            Mobile Number: {client?.contact_number}{"\n"}
            E Mail: {client?.email}
          </Text>
        </View>
      </View>
    </Fragment>
  );
};

export default CustomerName;
